<template>
    <div class="Solicitudes">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-dollar</v-icon>
                                Lista de Solicitudes de Pago
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="solicitudEstado"
                                    label="Solicitudes"
                                    :items="[
                                        { text: 'Todas', value: '1' },
                                        { text: 'Pendientes', value: '2' },
                                        { text: 'Pagadas', value: '3' },
                                        // { text: 'Deshabilitadas', value: '4' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadSolicitud()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1 mr-2" inset vertical></v-divider>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon flat :loading="loadingTotales" @click="openTotales">
                                        <v-icon medium class="pb-2" v-on="on">T</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver montos totales</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon flat :disabled="loadingTotales" @click="openStats">
                                        <v-icon medium v-on="on">fa-bar-chart</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver montos</span>
                            </v-tooltip>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>
                            <v-menu
                                v-model="exportMenu"
                                origin="center center"
                                class="elelvation-1"
                                transition="slide-y-transition"
                                left
                                max-width="350"
                                max-height="500"
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on: menu }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn icon flat>
                                                <v-icon medium v-on="{ ...tooltip, ...menu }">fa fa-save</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Exportar Solicitudes</span>
                                    </v-tooltip>
                                </template>
                                <v-card>
                                    <v-card-text pb-0>
                                        <v-text-field v-model="filename" label="Nombre del documento">
                                        </v-text-field>
                                        <v-flex sm12 class="pb-3">
                                            <v-label>Columnas a exportar</v-label>
                                        </v-flex>
                                        <v-container fluid grid-list-xl py-0>
                                            <v-layout align-center wrap>
                                                <v-flex
                                                    xs12
                                                    sm6
                                                    class="pa-0"
                                                    v-for="column in excelColumns"
                                                    :key="column.field"
                                                >
                                                    <v-checkbox
                                                        v-model="column.status"
                                                        class="pt-0 mt-0"
                                                        :label="column.label"
                                                        :key="column.field"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="red" @click="exportMenu = false" flat >
                                            Cancelar
                                        </v-btn>
                                        <v-btn @click="exportar" color="success" flat>
                                            Exportar
                                        </v-btn>

                                    </v-card-actions>
                                </v-card>
                            </v-menu>

                            <v-toolbar-items>
                                <v-btn icon :disabled="loadingTotales" @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="filtroMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat :disabled="loadingTotales">
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-solicitud-pago
                                        v-if="filtroMenu"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-solicitud-pago>
                                </v-menu>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat :disabled="loadingTotales" @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Solicitud</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="SOLICITUDES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <template v-progress-linear v-slot:progress color="green" indeterminate></template>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.id }}</td>
                                        <td>{{ props.item.nombre_solicitante }}</td>
                                        <td>
                                            {{ props.item.monto }}
                                        </td>
                                        <td>
                                            <v-icon :disabled="true">fa-calendar</v-icon>
                                            {{ props.item.fecha_pago }}
                                        </td>
                                        <td>{{ props.item.campus ? getCampusValue(props.item.campus) : "-" }}</td>
                                        <td>{{ props.item.departamento ? props.item.departamento.nombre : "-" }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :disabled="loading || menuLocked"
                                                            @click="openDetails(props.item)"
                                                        >
                                                            <v-icon v-on="on" medium>fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver detalles</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked || props.item.estado === 0"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Deshabilitar Solicitud</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="primary"
                                                            :disabled="loading || menuLocked"
                                                            @click="expandRow(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-list</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Opciones</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <template v-if="columnExpanded">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="primary"
                                                            :disabled="props.item.estado !== 1"
                                                            @click="pagarSolicitud(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-thumbs-up</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Realizar pago</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="orange" @click="openForm(props)">
                                                            <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Solicitud</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            @click="loadHistory(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </template>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <template v-if="!columnExpanded">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            icon
                                                            flat
                                                            color="green"
                                                            @click="deleteItemConfirm(props)"
                                                        >
                                                            <v-icon v-on="on">fa-check</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Confirmar acción</span>
                                                </v-tooltip>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen solicitudes de pago registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <solicitud-pago-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </solicitud-pago-form>

        <solicitud-pago-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails">
        </solicitud-pago-details>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Solicitud de pago'"
            @formCanceled="showHistory = false"
        ></time-line>

        <solicitud-pago-totales
            v-if="totalesShow"
            :initial-item="totalesdata"
            @formCanceled="totalesShow = false"
        ></solicitud-pago-totales>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const SolicitudPagoTotales = () =>
    import(/* webpackChunkName: "pagos-totales" */ "@/components/finanzas/solicitud-pago/solicitud-pago-totales")
const TimeLine = () =>
    import(/* webpackChunkName: "historiales-time-line" */ "@/components/widgets/records-time-line/time-line")
const SolicitudPagoForm = () =>
    import(/* webpackChunkName: "pagos-form" */ "@/components/finanzas/solicitud-pago/solicitud-pago-form")
const SolicitudPagoDetails = () =>
    import(/* webpackChunkName: "pagos-details" */ "@/components/finanzas/solicitud-pago/solicitud-pago-details")
const CustomFilterSolicitudPago = () =>
    import(/* webpackChunkName: "pagos-filter" */ "@/components/widgets/custom-filter-solicitud-pago/custom-filter-solicitud-pago")
export default {
    components: { SolicitudPagoTotales, CustomFilterSolicitudPago, SolicitudPagoDetails, SolicitudPagoForm, TimeLine },
    props: {
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",

        //menu exportar
        exportMenu: false,
        excelColumns: Util.SolicitudPagosExcelColumns(),
        filename: "SolicitudPagos",

        showForm: false,
        headers: [
            { text: "No", value: "id" },
            { text: "Solicitante", value: "nombre_solicitante" },
            { text: "Montos", value: "monto" },
            { text: "Fecha pago", value: "fecha_pago" },
            { text: "Campus", value: "campus_id" },
            { text: "Departamento", value: "departamento_id" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteConfirmId: "",

        menuLocked: false,

        showDetails: false,
        detailsItem: null,

        //filtro personalizado
        filtroMenu: false,
        customFilter: null,
        activeFilters: 0,

        exportFilter: false,

        //estado de las solicitudes a cargar del back
        solicitudEstado: "1",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //para saber si hay una columna expandida
        columnExpanded: false,

        //totales dialog
        totalesShow: false,
        totalesdata: null,
        loadingTotales: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_SOLICITUDES", {
                    filter: this.filter.search,
                    solicitudEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(props) {
            if (props !== null) {
                this.title = "Modificar solicitud"
                this.editItem = props.item
                this.expandRowCancel(props)
            } else {
                this.title = "Nueva solicitud"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_SOLICITUD", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteConfirmId = ""
            this.columnExpanded = false
            props.expanded = !props.expanded
        },

        loadSolicitud() {
            this.loadData(this.solicitudEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        loadHistory(props) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("SolicitudPago")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: props.item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.solicitudEstado, this.customfilter)
        }, 1000),

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(item) {
            if (!this.SOLICITUDES.filter(el => el.id === item.id)[0].tipo_monto) {
                //condicion para saber si los datos de este empleado ya se cargaron para no volver a pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_SOLICITUD_DETAILS", item).then(error => {
                    if (error === null) {
                        this.detailsItem = item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            } else {
                this.detailsItem = item
                this.showDetails = true
            }
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroMenu = false
                this.solicitudEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.solicitudEstado, this.customfilter)
            } else {
                this.solicitudEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.solicitudEstado, this.customfilter)
                this.filtroMenu = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        expandRow(props) {
            this.columnExpanded = true
            props.expanded = !props.expanded
            this.menuLocked = true
        },

        expandRowCancel(props) {
            this.columnExpanded = false
            props.expanded = !props.expanded
            this.menuLocked = false
        },

        pagarSolicitud(props) {
            this.loading = true
            this.$store.dispatch("PAY_SOLICITUD", props.item).then(() => {
                this.loading = false
                this.expandRowCancel(props)
            })
        },

        exportar() {
            let cols = this.excelColumns.filter(el => el.status)
            var cols_str =''
            cols.forEach(item => cols_str=cols_str.concat(item['field'].concat(',')))
            cols_str = cols_str.substring(0,cols_str.length-1)
            //let p = 'columns='.concat(cols_str)
            let p = {
                columns: cols_str,
                ...this.customfilter
            }
            this.$store.dispatch("EXPORT", p).then(response => {
                if (response) {
                    let blob = new Blob([response], { type: response.type })
                    let link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = this.filename.concat(`.xlsx`)
                    link.click()
                }
            })

            // const requestOptions = {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json"
            //     },
            //     body: JSON.stringify({title : 'Example'})
            // };
            //
            // fetch('http://api.nubikids.com/v1/export',requestOptions)
            //  .then(response=>response.json())
            // .then(data=>cols_str=data.columns)

            // this.$store.dispatch("EXPORT", props.selectedColumns).then(() => {
            //
            //     this.loading = false
            //     this.expandRowCancel(props)
            // })
        },

        toexcel() {

        },

        openTotales() {
            this.loadingTotales = true
            this.$store.dispatch("LOAD_MONTOS_TOTAL").then(response => {
                if (response) {
                    this.totalesdata = response
                    this.loadingTotales = false
                    this.totalesShow = true
                } else this.loadingTotales = false
            })
        },

        openStats() {
            this.$router.push({ name: "solicitud-pago-stats" })
        },

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "orange lighten-1"
                case 2:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "orange lighten-1"
                case "3":
                    return "success lighten-1"
                case "4":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        getCampusValue(campus) {
            if (campus.length === 1) {
                return campus[0].nombre
            } else {
                let value = ""
                campus.map(item => (value += item.nombre.substring(0, 3) + "-"))
                value = value.slice(0, -1)
                return value
            }
        }
    },

    computed: {
        ...mapGetters(["SOLICITUDES"]),

        pagination: {
            get: function() {
                return this.$store.getters.SOLICITUDES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_SOLICITUDES_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        },
        computedExcelColumns() {
            return this.excelColumns.filter(el => el.status)
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.solicitudEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.solicitudEstado, this.customfilter)
            },
            deep: true
        },

        searchTerm() {
            this.searchData()
        }
    }
}
</script>
